import React from "react";
import {
  required,
  SelectInput,
  ReferenceInput,
  NumberInput,
  FormDataConsumer,
  ArrayInput,
  SimpleFormIterator,
  Button,
} from "react-admin";
import { Grid, Typography } from "@mui/material";
import { administrationRequests } from "api/administrationApi";
import ExamsSlots from "./ExamsSlots";
import { ExamCategories, ExamTypes } from "utils/constants";
import CloseIcon from "@mui/icons-material/Close";
import { useFormContext } from "react-hook-form";
import { settings } from "app";

const RegularCampaignExamList = ({ examsChanged, readOnly }) => {
  const { setValue, getValues } = useFormContext();

  const handleRemoveExam = examId => {
    const currentExams = getValues().exams;

    const updatedExams = currentExams.filter(exam => exam.examId !== examId);
    setValue("exams", updatedExams);
    examsChanged(updatedExams);
  };
  return (
    <>
      <Grid
        container
        spacing={1}
        sx={{ marginLeft: 1, marginBottom: 4 }}
        gap={1}
      >
        <ArrayInput
          source="exams"
          label=" "
          defaultValue={[{}]}
        >
          <SimpleFormIterator
            disableReordering
            disableRemove
            disableAdd
            inline
            sx={settings.style.iteratorWithoutGap}
          >
            <FormDataConsumer>
              {({ formData, scopedFormData }) => {
                const currentExamIndex = formData?.exams?.findIndex(exam => exam.examId === scopedFormData?.examId);
                return (
                  <Grid
                    container
                    spacing={1}
                  >
                    <Grid
                      item
                      xs={12}
                      md={10}
                    >
                      <Typography color="primary">Изпит</Typography>
                      <Typography>{scopedFormData?.examName}</Typography>
                      <NumberInput
                        source="examId"
                        sx={{ display: "none" }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={2}
                    >
                      <Button
                        variant="outlined"
                        label="Премахни"
                        size="medium"
                        color="error"
                        onClick={() => handleRemoveExam(scopedFormData.examId)}
                        disabled={readOnly}
                      >
                        <CloseIcon />
                      </Button>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={3}
                    >
                      <ReferenceInput
                        source="examTypeId"
                        reference={administrationRequests.getExamTypesSelect()}
                      >
                        <SelectInput
                          label="Тип"
                          validate={[required()]}
                          optionText="nameBg"
                          readOnly={readOnly}
                        />
                      </ReferenceInput>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={3}
                    >
                      <ReferenceInput
                        source="examCategoryId"
                        reference={administrationRequests.getExamCategoriesSelect()}
                      >
                        <SelectInput
                          label="Категория"
                          validate={[required()]}
                          optionText="nameBg"
                          readOnly={readOnly}
                        />
                      </ReferenceInput>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={3}
                    >
                      <ReferenceInput
                        source="instructionLanguageId"
                        reference={administrationRequests.getInstructionLanguagesSelect()}
                        alwaysOn
                      >
                        <SelectInput
                          label="Език на преподаване"
                          emptyText={"Всички"}
                          emptyValue={0}
                          defaultValue={0}
                          readOnly={readOnly}
                        />
                      </ReferenceInput>
                    </Grid>
                    {scopedFormData?.examTypeId === ExamTypes.Remote && (
                      <Grid
                        item
                        xs={12}
                        md={3}
                      >
                        <ReferenceInput
                          source="gradingScaleId"
                          reference={administrationRequests.getGradingScalesSelect()}
                        >
                          <SelectInput
                            label="Скала за оценяване"
                            validate={[required()]}
                            readOnly={readOnly}
                          />
                        </ReferenceInput>
                      </Grid>
                    )}
                    {scopedFormData?.examCategoryId &&
                      scopedFormData?.examCategoryId !== ExamCategories.DocumentBased && (
                        <ExamsSlots
                          examCategoryId={scopedFormData?.examCategoryId}
                          examIndex={currentExamIndex}
                          examTypeId={scopedFormData?.examTypeId}
                          readOnly={readOnly}
                        />
                      )}
                  </Grid>
                );
              }}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </>
  );
};

export default RegularCampaignExamList;
